// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OMQHJ","left":"styles_left__cxYR3","right":"styles_right__2Wp0d","alert":"styles_alert__2gEqs"};